import { render, staticRenderFns } from "./CountersSection.vue?vue&type=template&id=54aed4fa&scoped=true"
import script from "./CountersSection.vue?vue&type=script&lang=js"
export * from "./CountersSection.vue?vue&type=script&lang=js"
import style0 from "./CountersSection.vue?vue&type=style&index=0&id=54aed4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aed4fa",
  null
  
)

export default component.exports